import styled from '@emotion/styled';
import {ReactComponent as SubscriptionSVG} from '../../assets/icons/ic_subscription.svg';

export const IconSubscription = styled(SubscriptionSVG)`
  width: ${({theme}) => theme.icon.size.lg};
  height: ${({theme}) => theme.icon.size.lg};
  fill: ${({theme}) => theme.color.neutral.grey_900};
`;
